import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["id"]
const _hoisted_4 = ["id"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["id"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/user/create" }, "アカウントを作成")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/user/paswordreset" }, "ログインできない方はこちら")
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createElementVNode("a", { href: "/law" }, "特定商取引法に基づく表記")
], -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { href: "/user/mypage" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.$style.parent
  }, [
    (!_ctx.state.session)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            id: _ctx.$style.pcFormParent
          }, [
            _createVNode(_component_el_form, {
              model: _ctx.state.loginData,
              "label-width": "120px",
              "label-position": "left"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: _ctx.$style.pcFormInputParent
                }, [
                  _createVNode(_component_el_form_item, { label: "メールアドレス" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.state.loginData.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.loginData.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "パスワード" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        modelValue: _ctx.state.loginData.pass,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.loginData.pass) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 8, _hoisted_4)
              ]),
              _: 1
            }, 8, ["model"])
          ], 8, _hoisted_3),
          _createElementVNode("div", {
            id: _ctx.$style.spFormParent
          }, [
            _createVNode(_component_el_form, {
              model: _ctx.state.loginData,
              "label-width": "80px",
              "label-position": "top"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  id: _ctx.$style.spFormInputParent
                }, [
                  _createVNode(_component_el_form_item, {
                    label: "メールアドレス",
                    class: _normalizeClass(_ctx.$style.sp_form_contents)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.state.loginData.email,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.loginData.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["class"]),
                  _createVNode(_component_el_form_item, {
                    label: "パスワード",
                    class: _normalizeClass(_ctx.$style.sp_form_contents)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        type: "password",
                        modelValue: _ctx.state.loginData.pass,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.loginData.pass) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["class"])
                ], 8, _hoisted_6)
              ]),
              _: 1
            }, 8, ["model"])
          ], 8, _hoisted_5),
          _createVNode(_component_el_button, {
            color: _ctx.BUTTON_COLOR,
            round: true,
            onClick: _ctx.login
          }, {
            default: _withCtx(() => [
              _createTextVNode("ログイン")
            ]),
            _: 1
          }, 8, ["color", "onClick"]),
          _hoisted_7,
          _hoisted_8,
          _hoisted_9
        ]))
      : _createCommentVNode("", true),
    (_ctx.state.session)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createTextVNode(" ログアウトしますか？ "),
          _hoisted_11,
          _createVNode(_component_el_button, {
            class: _normalizeClass(_ctx.$style.logout_btn),
            color: _ctx.BUTTON_COLOR,
            round: true,
            onClick: _ctx.logout
          }, {
            default: _withCtx(() => [
              _createTextVNode("はい")
            ]),
            _: 1
          }, 8, ["class", "color", "onClick"]),
          _createElementVNode("a", _hoisted_12, [
            _createVNode(_component_el_button, {
              class: _normalizeClass(_ctx.$style.logout_btn),
              color: _ctx.BUTTON_COLOR,
              round: true
            }, {
              default: _withCtx(() => [
                _createTextVNode("マイページに戻る")
              ]),
              _: 1
            }, 8, ["class", "color"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 8, _hoisted_1))
}